export default __webpack_public_path__ + "3affe3d625880e400546bc3dbe0d058b.png";